/* GeoChange V2 · Mobile CRO 2026-09-23 · "Collect something that means more" accordion (mobile ≤ 900 px only).
   Desktop: every panel open, buttons inert. Mobile: first row expanded, one tap per row, native button keyboard
   handling plus Up/Down/Home/End between rows. No timers, no observers, no layout animation. */
(function(){
  var mq=window.matchMedia('(max-width:900px)');
  function rows(){ return Array.prototype.slice.call(document.querySelectorAll('.mm-b .mm-t')); }
  function panel(b){ return document.getElementById(b.getAttribute('aria-controls')); }
  function set(b,open){ b.setAttribute('aria-expanded',open?'true':'false'); var p=panel(b); if(p){ if(open) p.removeAttribute('hidden'); else p.setAttribute('hidden',''); } }
  function apply(){
    var R=rows(); if(!R.length) return;
    if(mq.matches){ R.forEach(function(b,i){ b.disabled=false; set(b, b.dataset.user ? b.dataset.user==='open' : false); }); } /* FINAL CRO 2026-09-25 (Alex): every row starts COLLAPSED on mobile */
    else { R.forEach(function(b){ b.disabled=true; set(b,true); }); }
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('.mm-b .mm-t'); if(!b||!mq.matches) return; e.preventDefault();
    var open=b.getAttribute('aria-expanded')!=='true'; if(open){ rows().forEach(function(o){ if(o!==b){ set(o,false); o.dataset.user='closed'; } }); } set(b,open); b.dataset.user=open?'open':'closed'; /* one open at a time */
    if(window.GCTrack) GCTrack('means_accordion',{row:b.id,open:open});
  });
  document.addEventListener('keydown',function(e){
    var b=e.target.closest&&e.target.closest('.mm-b .mm-t'); if(!b||!mq.matches) return;
    var R=rows(), i=R.indexOf(b), n=null;
    if(e.key==='ArrowDown') n=R[(i+1)%R.length]; else if(e.key==='ArrowUp') n=R[(i-1+R.length)%R.length]; else if(e.key==='Home') n=R[0]; else if(e.key==='End') n=R[R.length-1];
    if(n){ e.preventDefault(); n.focus(); }
  });
  if(mq.addEventListener) mq.addEventListener('change',apply); else if(mq.addListener) mq.addListener(apply);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',apply); else apply();
})();
